import { render, staticRenderFns } from "./NarasuCampaign202506_01.vue?vue&type=template&id=6dd6d222&scoped=true&"
import script from "./NarasuCampaign202506_01.vue?vue&type=script&lang=js&"
export * from "./NarasuCampaign202506_01.vue?vue&type=script&lang=js&"
import style0 from "./NarasuCampaign202506_01.vue?vue&type=style&index=0&id=6dd6d222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd6d222",
  null
  
)

export default component.exports